import React from 'react';
import { Box} from '@mui/material';
import { Container } from '@mui/material';



import UpdateBuilderBranchForm from '../Components/UpdateBuilderBranchForm';

export default function UpdateBuilderBranchPage() {
  return (
    <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
      <Container>
        <UpdateBuilderBranchForm/>
      </Container>
    </Box>
  )
}
